var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: {
        "class-name": "remove-transaction-modal",
        active: _vm.displayModal,
        title: "Удаление проводки",
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                staticClass: "reset",
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                staticClass: "save",
                attrs: {
                  disabled: _vm.pending,
                  label: "Удалить",
                  color: "secondary",
                  size: "large",
                },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("error-feedback", {
        staticClass: "warning",
        attrs: {
          text: "При удалении проводки изменится баланс на Личном счёте сотрудника, а также информация в связанных проводках",
        },
      }),
      _c("c-input", {
        staticClass: "comment",
        class: { "is-invalid": _vm.isSubmitted && _vm.commentError },
        attrs: {
          type: "textarea",
          "floating-label": "Комментарий",
          clearable: true,
          "required-mark": true,
          invalid: _vm.isSubmitted && _vm.commentError,
          error: _vm.isSubmitted && _vm.commentError,
          "max-length": "255",
        },
        model: {
          value: _vm.comment,
          callback: function ($$v) {
            _vm.comment = $$v
          },
          expression: "comment",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }